module.exports = __webpack_public_path__ + "img/logo_jp.b6ca6d99.png";